"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORE_WARNING = exports.HIDDEN_FIELDS_CACHE = exports.ELEMENT_CACHE = exports.DISABLED_CACHE = exports.SEARCHED = exports.ID = exports.FILTERED = exports.VISIBLE = exports.GROUP_HEADER = exports.FORM_EXPANDED = exports.EXPANDED = exports.SELECTED = void 0;
/**
 * Data Keys
 */
exports.SELECTED = 'selectedRow';
exports.EXPANDED = 'expandedRow';
exports.FORM_EXPANDED = 'expandedForm';
exports.GROUP_HEADER = 'groupHeader';
exports.VISIBLE = 'rowVisible';
exports.FILTERED = 'rowFiltered';
exports.ID = 'rowId';
exports.SEARCHED = 'searchFilter';
/**
 * Cache Key Contants
 */
exports.DISABLED_CACHE = '_disabledCache';
exports.ELEMENT_CACHE = '_elementConfigCache';
exports.HIDDEN_FIELDS_CACHE = '_hiddenFieldsCache';
/**
 * Creates a styled console warning message.
 * @param message
 * @constructor
 */
const CORE_WARNING = (message) => {
    console.warn(`%c☢ FLUID CORE ☢%c ${message}`, 'font-size: 10px; font-weight: bold; padding: 2px 5px 1px 5px; background-color: ##3ff00; color: #4E3E00; border: 1px solid #a7ca00; border-radius: 3px;', '');
};
exports.CORE_WARNING = CORE_WARNING;
